import { useEffect, useRef } from 'react';
import type { StepState } from '../../lib/preflightSteps';
import { prefersReducedMotion } from './hooks';

/**
 * One SVG that morphs between states with CSS only: dashed ring → filled
 * ring with a drawn check (complete), an exclamation (warning), a padlock
 * (locked) or a spinner (running). Pops once when a step turns complete.
 */
export function StepGlyph({ state }: { state: StepState }) {
  const ref = useRef<SVGSVGElement>(null);
  const prev = useRef(state);
  useEffect(() => {
    const el = ref.current;
    if (el && prev.current !== state && state === 'complete' && !prefersReducedMotion()) {
      el.classList.remove('pf-pop');
      void el.getBoundingClientRect();
      el.classList.add('pf-pop');
    }
    prev.current = state;
  }, [state]);
  return (
    <svg ref={ref} className="pf-glyph" data-s={state} viewBox="0 0 24 24" aria-hidden="true">
      <circle className="pf-g-ring" cx="12" cy="12" r="10" />
      <path className="pf-g-ck" d="M7.6 12.4l3 3 5.8-6.2" />
      <path className="pf-g-ex" d="M12 7.4v5.4M12 16.3v.1" />
      <g className="pf-g-lk">
        <rect x="8.6" y="11" width="6.8" height="5.2" rx="1.2" />
        <path d="M10.1 11V9.6a1.9 1.9 0 0 1 3.8 0V11" />
      </g>
      <circle className="pf-g-sp" cx="12" cy="12" r="10" />
    </svg>
  );
}

export const STATE_TEXT: Record<StepState, string> = {
  complete: 'ready',
  warning: 'needs attention',
  incomplete: 'not done',
  locked: 'locked',
  running: 'running',
};
